import React, { forwardRef } from "react";
import Modal from "react-responsive-modal";

const DEFAULT_VIEWPORT_STYLES = {
  root: {
    height: "100dvh",
    inset: 0,
    position: "fixed",
    width: "100vw",
  },
  overlay: {
    height: "100dvh",
    inset: 0,
    position: "fixed",
    width: "100vw",
  },
  modalContainer: {
    height: "100dvh",
    minHeight: "100dvh",
  },
};

export function getRailsModalContainer() {
  if (typeof document === "undefined") return null;

  promotePortalRoot("rails-portal-root");

  return (
    document.getElementById("rails-portal-root") ||
    document.getElementById("rails-root") ||
    document.body
  );
}

function promotePortalRoot(id) {
  if (!document.body) return;

  const roots = Array.from(document.querySelectorAll(`#${id}`));
  let bodyRoot = roots.find((root) => root.parentElement === document.body);

  roots.forEach((root) => {
    if (root.parentElement === document.body) return;

    if (!bodyRoot) {
      document.body.appendChild(root);
      bodyRoot = root;
      return;
    }

    while (root.firstChild) {
      bodyRoot.appendChild(root.firstChild);
    }
    root.remove();
  });
}

function mergeViewportStyles(styles = {}) {
  return {
    ...styles,
    root: {
      ...DEFAULT_VIEWPORT_STYLES.root,
      ...styles.root,
    },
    overlay: {
      ...DEFAULT_VIEWPORT_STYLES.overlay,
      ...styles.overlay,
    },
    modalContainer: {
      ...DEFAULT_VIEWPORT_STYLES.modalContainer,
      ...styles.modalContainer,
    },
  };
}

const ScopedModal = forwardRef(({ container, styles, ...props }, ref) => (
  <Modal
    ref={ref}
    container={container || getRailsModalContainer()}
    styles={mergeViewportStyles(styles)}
    {...props}
  />
));

ScopedModal.displayName = "ScopedModal";

export default ScopedModal;
